import React, { Component } from 'react';
import Button from '@atlaskit/button';

import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { ct } from '../../constant-Utils';

export default class Jamulus extends Component {
  constructor(props) {
    super(props);
    this.state = {
        os: null,
        fileName: null
    };
  }

  componentDidMount() {
    // Detect operating system
    if (navigator.userAgent.indexOf("Win") != -1) {
      // window
      this.setState({
        os: 'window',
        fileName: 'jamulus.exe'
      });
    }
    if (navigator.userAgent.indexOf("Mac") != -1) {
      // mac
      this.setState({
        os: 'mac',
        fileName: 'Jamulus.dmg'
      });
    }
    if (navigator.userAgent.indexOf("Linux") != -1)  {
      // linux
      this.setState({
        os: 'linux',
        fileName: 'Jamulus.tar.gz'
      });
    }
  }

  // downloading the jamulus
  downloadJamulus = () =>{
    const { closeJam } = this.props;
    const { os, fileName } = this.state;

    setTimeout(() => {
      const response = {
        file: `https://${ window.location.hostname }/static/jam-app/${ os }/${ fileName }`,
      };

      if(os) {
        window.open(response.file, "_blank");
      } else {
        alert(ct("rta-trmc.jamulus.unknownOperatingSys"));
      }
    }, 100);

    // closing the dailog box
    closeJam();
  }

  // render method
  render() {
    const { isOpen, closeJam } = this.props;

    const actions = [
      { text: ct("rta-trmc.jamulus.download"), onClick: this.downloadJamulus },
      { text: ct("Translate.buttonTitle.closeSmall"), onClick: closeJam },
    ];

    return (
      <div>
        <ModalTransition>
          {isOpen && (
            <Modal actions={actions} onClose={closeJam} heading={ct("rta-trmc.jamulus.modalTitle")}>
              <ol>
                <li>{ct("rta-trmc.jamulus.installApp")}</li>
                <li>{ct("rta-trmc.jamulus.plugInAudio")}</li>
                <li>{ct("rta-trmc.jamulus.setAudioInterface")}</li>
                <li>{ct("rta-trmc.jamulus.openJamulusApp")}</li>
                <li>{ct("rta-trmc.jamulus.connectBtn")}</li>
                <li>{ct("rta-trmc.jamulus.chooseServer")}</li>
                <li>{ct("rta-trmc.jamulus.muteMicrophone")}</li>
              </ol>
              <span>{ct("rta-trmc.jamulus.note")}</span>
            </Modal>
          )}
        </ModalTransition>
      </div>
    );
  }
}
